'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_RecipeSort(sortType, direction) {
  this.zh = null;
  this.zg = null;
  this.zh = sortType;
  this.zg = direction;
}
export { $c_Lmealorama_RecipeSort as $c_Lmealorama_RecipeSort };
$p = $c_Lmealorama_RecipeSort.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_RecipeSort;
/** @constructor */
function $h_Lmealorama_RecipeSort() {
}
export { $h_Lmealorama_RecipeSort as $h_Lmealorama_RecipeSort };
$h_Lmealorama_RecipeSort.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-1896793908), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_RecipeSort)) {
    var x = this.zh;
    var x$2 = x$0.zh;
    if (((x === null) ? (x$2 === null) : (x === x$2))) {
      var x$3 = this.zg;
      var x$4 = x$0.zg;
      return ((x$3 === null) ? (x$4 === null) : (x$3 === x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 2;
});
$p.r = (function() {
  return "RecipeSort";
});
$p.g = (function(n) {
  if ((n === 0)) {
    return this.zh;
  }
  if ((n === 1)) {
    return this.zg;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
});
function $isArrayOf_Lmealorama_RecipeSort(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jP)));
}
export { $isArrayOf_Lmealorama_RecipeSort as $isArrayOf_Lmealorama_RecipeSort };
var $d_Lmealorama_RecipeSort = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_RecipeSort, "mealorama.RecipeSort", ({
  jP: 1,
  eK: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_RecipeSort as $d_Lmealorama_RecipeSort };
//# sourceMappingURL=mealorama.-Recipe-Sort.js.map
